(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["linkd-mobile-promo"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const widgetSelector = '.widget.widget-bar.widget-bar-sticky.widget-bar-bottom';
    let shadowRoot;
    let currentWidget;
    let discoveryTimer;
    let discoveryAttempts = 0;
    let updateFrame;
    let lastHeight = 0;
    const resizeObserver = new ResizeObserver(() => scheduleUpdate());
    const observer = new MutationObserver(() => scheduleUpdate());

    function scheduleUpdate() {
      if (updateFrame) return;
      updateFrame = requestAnimationFrame(update);
    }

    function setHeight(height) {
      if (lastHeight === height) return;
      lastHeight = height;
      document.documentElement.style.setProperty('--ld-mobile-promo-height', `${height}px`);
    }

    function update() {
      updateFrame = 0;
      if (!shadowRoot || !mobile.matches) { setHeight(0); return; }
      const widget = [...shadowRoot.querySelectorAll(widgetSelector)].find((candidate) =>
        candidate.querySelector('.discount .discount-code')?.textContent.trim() === 'FIRSTLINKD10'
      );
      if (widget !== currentWidget) {
        if (currentWidget) {
          resizeObserver.unobserve(currentWidget);
          currentWidget.removeAttribute('data-linkd-mobile-coupon');
        }
        currentWidget = widget;
        if (widget) {
          widget.setAttribute('data-linkd-mobile-coupon', '');
          resizeObserver.observe(widget);
        }
      }
      if (!widget || !widget.classList.contains('widget-bar-open')) { setHeight(0); return; }
      const bounds = widget.getBoundingClientRect();
      const style = getComputedStyle(widget);
      const visible = widget.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0 && bounds.bottom > 0 && bounds.top < window.innerHeight;
      setHeight(visible ? Math.max(0, Math.ceil(window.innerHeight - bounds.top)) : 0);
    }

    function attach(root) {
      shadowRoot = root;
      if (!root.querySelector('#linkd-mobile-coupon-style')) {
        const style = document.createElement('style');
        style.id = 'linkd-mobile-coupon-style';
        style.textContent = `
          @media (max-width: 749px) {
            .widget.widget-bar.widget-bar-bottom[data-linkd-mobile-coupon] {
              box-sizing: border-box !important;
              min-height: 56px !important;
              height: auto !important;
              max-height: none !important;
              padding: 6px 50px calc(6px + env(safe-area-inset-bottom)) 12px !important;
            }
            [data-linkd-mobile-coupon] .views,
            [data-linkd-mobile-coupon] .view,
            [data-linkd-mobile-coupon] .content {
              box-sizing: border-box !important;
              width: 100% !important;
              min-width: 0 !important;
              min-height: 0 !important;
              height: auto !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            [data-linkd-mobile-coupon] .content {
              display: flex !important;
              flex-direction: row !important;
              flex-wrap: nowrap !important;
              align-items: center !important;
              justify-content: space-between !important;
              gap: 8px !important;
            }
            [data-linkd-mobile-coupon] .text {
              flex: 1 1 auto !important;
              min-width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              font-size: 12px !important;
              line-height: 1.35 !important;
              text-align: left !important;
            }
            [data-linkd-mobile-coupon] .text p { margin: 0 !important; }
            [data-linkd-mobile-coupon] .discount {
              display: inline-flex !important;
              flex: 0 0 auto !important;
              align-items: center !important;
              margin: 0 !important;
              padding: 0 !important;
              border: 0 !important;
              background: none !important;
            }
            [data-linkd-mobile-coupon] .discount-code {
              display: inline-flex !important;
              align-items: center !important;
              justify-content: center !important;
              min-height: 44px !important;
              min-width: 44px !important;
              padding: 0 8px !important;
              font-size: 12px !important;
              line-height: 1.2 !important;
              border: 1px dashed currentColor !important;
              border-radius: 8px !important;
            }
            [data-linkd-mobile-coupon] .discount-help { display: none !important; }
            [data-linkd-mobile-coupon] button.close {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              position: absolute !important;
              top: 6px !important;
              right: 3px !important;
              width: 44px !important;
              height: 44px !important;
              min-width: 44px !important;
              min-height: 44px !important;
              margin: 0 !important;
              padding: 0 !important;
              transform: none !important;
            }
          }
        `;
        root.append(style);
      }
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      root.addEventListener('transitionend', scheduleUpdate);
      root.addEventListener('animationend', scheduleUpdate);
      scheduleUpdate();
    }

    function discover() {
      discoveryTimer = 0;
      if (shadowRoot || !mobile.matches) return;
      const root = document.getElementById('yeps-widget')?.shadowRoot;
      if (root) { attach(root); return; }
      discoveryAttempts += 1;
      if (discoveryAttempts < 60) discoveryTimer = setTimeout(discover, 500);
    }

    mobile.addEventListener('change', () => {
      clearTimeout(discoveryTimer);
      discoveryAttempts = 0;
      if (!shadowRoot) discover();
      scheduleUpdate();
    });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', () => {
      if (!shadowRoot && !discoveryTimer) { discoveryAttempts = 0; discover(); }
      scheduleUpdate();
    });
    discover();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["linkd-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('linkd-navigation')) {
    customElements.define('linkd-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-menu-open]');
        const disclosures = [...this.querySelectorAll('.ld-nav-disclosure')];
        if (dialog && trigger) {
          trigger.addEventListener('click', () => {
            dialog.showModal();
            trigger.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('linkd-menu-open');
          }, options);
          this.querySelector('[data-menu-close]').addEventListener('click', () => dialog.close(), options);
          dialog.addEventListener('click', event => {
            if (event.target === dialog) {
              const rect = dialog.getBoundingClientRect();
              if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
            }
          }, options);
          dialog.addEventListener('close', () => {
            document.documentElement.classList.remove('linkd-menu-open');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }, options);
        }
        if (disclosures.length) {
          const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
          const closeOthers = current => disclosures.forEach(details => { if (details !== current) details.open = false; });
          disclosures.forEach(details => {
            details.addEventListener('pointerenter', event => {
              if (!canHover.matches || event.pointerType === 'touch') return;
              clearTimeout(this.closeTimer);
              closeOthers(details);
              details.open = true;
            }, options);
            details.addEventListener('pointerleave', event => {
              if (!canHover.matches || event.pointerType === 'touch') return;
              clearTimeout(this.closeTimer);
              this.closeTimer = setTimeout(() => {
                if (!details.contains(document.activeElement)) details.open = false;
              }, 200);
            }, options);
            details.addEventListener('toggle', () => { if (details.open) closeOthers(details); }, options);
            details.addEventListener('focusout', event => {
              if (!details.contains(event.relatedTarget)) details.open = false;
            }, options);
          });
          document.addEventListener('click', event => {
            if (!this.contains(event.target)) disclosures.forEach(details => { details.open = false; });
          }, options);
          this.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              const openDetails = disclosures.find(details => details.open);
              if (openDetails) {
                event.preventDefault();
                clearTimeout(this.closeTimer);
                openDetails.open = false;
                openDetails.querySelector('summary').focus();
              }
            }
          }, options);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        if (this.querySelector('dialog[open]')) document.documentElement.classList.remove('linkd-menu-open');
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
